import { dispatch, getState, subscribe } from './state/store';
import { initRouter, writeHash } from './router/HashRouter';
import { initWindowManager, openApp } from './os/WindowManager';
import { initTaskbar } from './os/Taskbar';
import { initDesktop } from './os/Desktop';
import { initBootSplash } from './os/BootSplash';
import { initSkipNav } from './a11y/skipNav';
import { setAmbient, setMasterMute, setUiSounds, unlockAudio } from './audio/AudioEngine';

export function boot(app: HTMLElement): void {
  const os = document.createElement('div');
  os.id = 'os-root';
  const wm = document.createElement('div');
  wm.id = 'wm-root';
  app.append(os, wm);

  initSkipNav(app);
  initDesktop(os);
  initWindowManager(wm);
  initTaskbar(wm);
  initBootSplash(wm);

  setMasterMute(getState().mute);
  setUiSounds(getState().uiSounds);
  setAmbient(getState().ambientOn, getState().mute);

  subscribe((s, event) => {
    if (event.type === 'SET_MUTE') setMasterMute(s.mute);
    if (event.type === 'SET_UI_SOUNDS') setUiSounds(s.uiSounds);
    if (
      event.type === 'AUDIO_UNLOCK' ||
      event.type === 'TOGGLE_AMBIENT' ||
      event.type === 'SET_AMBIENT' ||
      event.type === 'SET_MUTE'
    ) {
      void unlockAudio();
      setAmbient(s.ambientOn, s.mute);
    }
    if (event.type === 'OPEN_WINDOW') {
      const exists = s.windows.some((w) => w.appId === event.appId);
      if (!exists) openApp(event.appId, event.payload);
      writeHash('push');
    }
    if (event.type === 'CLOSE_WINDOW' || event.type === 'FOCUS_WINDOW') {
      writeHash('push');
    }
    const splash = document.getElementById('boot-splash');
    if (splash) {
      const show = s.bootSplash;
      splash.classList.toggle('is-hidden', !show);
      splash.inert = !show;
    }
  });

  initRouter();
  writeHash('replace');

  if (!getState().reducedMotion && !getState().skipBoot) {
    dispatch({ type: 'BOOT_DONE' });
    const splash = document.getElementById('boot-splash');
    if (splash) {
      splash.classList.remove('is-hidden');
      splash.inert = false;
      window.setTimeout(() => {
        splash.classList.add('is-hidden');
        splash.inert = true;
      }, 900);
    }
  }

  window.addEventListener(
    'pointerdown',
    () => {
      dispatch({ type: 'AUDIO_UNLOCK' });
    },
    { once: true },
  );

  document.addEventListener('pointerdown', (e) => {
    const t = e.target as HTMLElement;
    if (!t.closest('.start-menu, .start-btn') && getState().startOpen) {
      dispatch({ type: 'TOGGLE_START', open: false });
    }
  });

  const mq = matchMedia('(prefers-reduced-motion: reduce)');
  mq.addEventListener('change', () => dispatch({ type: 'SET_REDUCED', value: mq.matches }));
}
